import { render, staticRenderFns } from "./OAuthSigninSection.vue?vue&type=template&id=727c0232&scoped=true"
import script from "./OAuthSigninSection.vue?vue&type=script&lang=js"
export * from "./OAuthSigninSection.vue?vue&type=script&lang=js"
import style0 from "./OAuthSigninSection.vue?vue&type=style&index=0&id=727c0232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c0232",
  null
  
)

export default component.exports